import React from 'react';
import { Divider } from '@blueprintjs/core'; import '../features/ConfigurationContent/ConfigurationStyle.css';

const DashboardPage = ({ onNext }) => {
    return (
        <div>
            <h6>End Session</h6>
            {/* DEBUG FUNCTIONALITY, REMOVE FOR FINAL VERSION */}
            {/*This page is currently under construction. It will be used to visualize aspects of the VR experience.*/}
            <p className="custom-label" style={{ width: "auto" }}>
                This page is currently under construction. It will be used to visualize aspects of the VR experience.
            </p>
            <Divider />
            <button onClick={onNext}>New Session</button>
        </div>
    );
};

export default DashboardPage;